import * as React from 'react';

interface INewHeaderGeoLinkIconProps {
  className?: string;
}
export function NewHeaderGeoLinkIcon(props: INewHeaderGeoLinkIconProps) {
  return (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 12 12">
      <path
        fill="#152242"
        fillRule="evenodd"
        d="M8.5 10.6L11 1.8a.7.7 0 00-.8-.8L1.5 3.5c-.6.2-.7 1-.1 1.2l4.1 1.7 1.7 4.2c.4.6 1.1.5 1.3 0z"
        clipRule="evenodd"
      />
    </svg>
  );
}
